<template>
    <img class="w-full h-auto" :src="currentFile ? currentFile.src : ''" />
</template>

<script>
import { mapGetters } from "vuex";

export default {
    name: "FileImage",
    computed: {
        ...mapGetters("player/view", ["currentFile"]),
    },
};
</script>
